import script from "./search-page-heading.vue?vue&type=script&setup=true&lang=js"
export * from "./search-page-heading.vue?vue&type=script&setup=true&lang=js"

import "./search-page-heading.vue?vue&type=style&index=0&id=2a27790f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a27790f"]])

export default __exports__